"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The RMISCarrierProfile model module.
 * @module model/RMISCarrierProfile
 * @version 2.7.64
 */
var RMISCarrierProfile = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>RMISCarrierProfile</code>.
   * @alias module:model/RMISCarrierProfile
   * @param hazmatCertVerifiedByRmis {Boolean} 
   */
  function RMISCarrierProfile(hazmatCertVerifiedByRmis) {
    _classCallCheck(this, RMISCarrierProfile);

    RMISCarrierProfile.initialize(this, hazmatCertVerifiedByRmis);
  }
  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */


  _createClass(RMISCarrierProfile, null, [{
    key: "initialize",
    value: function initialize(obj, hazmatCertVerifiedByRmis) {
      obj['hazmat_cert_verified_by_rmis'] = hazmatCertVerifiedByRmis;
    }
    /**
     * Constructs a <code>RMISCarrierProfile</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/RMISCarrierProfile} obj Optional instance to populate.
     * @return {module:model/RMISCarrierProfile} The populated <code>RMISCarrierProfile</code> instance.
     */

  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new RMISCarrierProfile();

        if (data.hasOwnProperty('bulk_trailer_count')) {
          obj['bulk_trailer_count'] = _ApiClient["default"].convertToType(data['bulk_trailer_count'], 'Number');
        }

        if (data.hasOwnProperty('cargo_vans')) {
          obj['cargo_vans'] = _ApiClient["default"].convertToType(data['cargo_vans'], 'Number');
        }

        if (data.hasOwnProperty('company_drivers')) {
          obj['company_drivers'] = _ApiClient["default"].convertToType(data['company_drivers'], 'Number');
        }

        if (data.hasOwnProperty('company_rep')) {
          obj['company_rep'] = _ApiClient["default"].convertToType(data['company_rep'], 'String');
        }

        if (data.hasOwnProperty('diversity_cert_agency')) {
          obj['diversity_cert_agency'] = _ApiClient["default"].convertToType(data['diversity_cert_agency'], 'String');
        }

        if (data.hasOwnProperty('double_drops')) {
          obj['double_drops'] = _ApiClient["default"].convertToType(data['double_drops'], 'Number');
        }

        if (data.hasOwnProperty('dry_vans')) {
          obj['dry_vans'] = _ApiClient["default"].convertToType(data['dry_vans'], 'Number');
        }

        if (data.hasOwnProperty('dump')) {
          obj['dump'] = _ApiClient["default"].convertToType(data['dump'], 'Number');
        }

        if (data.hasOwnProperty('email_received')) {
          obj['email_received'] = _ApiClient["default"].convertToType(data['email_received'], 'Boolean');
        }

        if (data.hasOwnProperty('expected_first_move_time')) {
          obj['expected_first_move_time'] = _ApiClient["default"].convertToType(data['expected_first_move_time'], 'String');
        }

        if (data.hasOwnProperty('flat_bed_48_foot')) {
          obj['flat_bed_48_foot'] = _ApiClient["default"].convertToType(data['flat_bed_48_foot'], 'Number');
        }

        if (data.hasOwnProperty('flat_bed_53_foot')) {
          obj['flat_bed_53_foot'] = _ApiClient["default"].convertToType(data['flat_bed_53_foot'], 'Number');
        }

        if (data.hasOwnProperty('flat_beds')) {
          obj['flat_beds'] = _ApiClient["default"].convertToType(data['flat_beds'], 'Number');
        }

        if (data.hasOwnProperty('garment_trailer')) {
          obj['garment_trailer'] = _ApiClient["default"].convertToType(data['garment_trailer'], 'Number');
        }

        if (data.hasOwnProperty('has_can_auth')) {
          obj['has_can_auth'] = _ApiClient["default"].convertToType(data['has_can_auth'], 'Boolean');
        }

        if (data.hasOwnProperty('has_carb_cert')) {
          obj['has_carb_cert'] = _ApiClient["default"].convertToType(data['has_carb_cert'], 'Boolean');
        }

        if (data.hasOwnProperty('has_ctpat_cert')) {
          obj['has_ctpat_cert'] = _ApiClient["default"].convertToType(data['has_ctpat_cert'], 'Boolean');
        }

        if (data.hasOwnProperty('has_fast_cert')) {
          obj['has_fast_cert'] = _ApiClient["default"].convertToType(data['has_fast_cert'], 'Boolean');
        }

        if (data.hasOwnProperty('has_mex_interchange')) {
          obj['has_mex_interchange'] = _ApiClient["default"].convertToType(data['has_mex_interchange'], 'Boolean');
        }

        if (data.hasOwnProperty('has_safety_permit_hm_32')) {
          obj['has_safety_permit_hm_32'] = _ApiClient["default"].convertToType(data['has_safety_permit_hm_32'], 'Boolean');
        }

        if (data.hasOwnProperty('has_smartway_cert')) {
          obj['has_smartway_cert'] = _ApiClient["default"].convertToType(data['has_smartway_cert'], 'Boolean');
        }

        if (data.hasOwnProperty('has_twice_cert')) {
          obj['has_twice_cert'] = _ApiClient["default"].convertToType(data['has_twice_cert'], 'Boolean');
        }

        if (data.hasOwnProperty('hazmat_cert_verified_by_rmis')) {
          obj['hazmat_cert_verified_by_rmis'] = _ApiClient["default"].convertToType(data['hazmat_cert_verified_by_rmis'], 'Boolean');
        }

        if (data.hasOwnProperty('hazmat_certified')) {
          obj['hazmat_certified'] = _ApiClient["default"].convertToType(data['hazmat_certified'], 'Boolean');
        }

        if (data.hasOwnProperty('heated_vans')) {
          obj['heated_vans'] = _ApiClient["default"].convertToType(data['heated_vans'], 'Number');
        }

        if (data.hasOwnProperty('hopper')) {
          obj['hopper'] = _ApiClient["default"].convertToType(data['hopper'], 'Number');
        }

        if (data.hasOwnProperty('intermodal_trailer_count')) {
          obj['intermodal_trailer_count'] = _ApiClient["default"].convertToType(data['intermodal_trailer_count'], 'Number');
        }

        if (data.hasOwnProperty('is_factoring')) {
          obj['is_factoring'] = _ApiClient["default"].convertToType(data['is_factoring'], 'Boolean');
        }

        if (data.hasOwnProperty('is_special_contract')) {
          obj['is_special_contract'] = _ApiClient["default"].convertToType(data['is_special_contract'], 'Boolean');
        }

        if (data.hasOwnProperty('maxi')) {
          obj['maxi'] = _ApiClient["default"].convertToType(data['maxi'], 'Number');
        }

        if (data.hasOwnProperty('minority_women_owned')) {
          obj['minority_women_owned'] = _ApiClient["default"].convertToType(data['minority_women_owned'], 'String');
        }

        if (data.hasOwnProperty('no_w9')) {
          obj['no_w9'] = _ApiClient["default"].convertToType(data['no_w9'], 'Boolean');
        }

        if (data.hasOwnProperty('open_top')) {
          obj['open_top'] = _ApiClient["default"].convertToType(data['open_top'], 'Number');
        }

        if (data.hasOwnProperty('other_trailer_count')) {
          obj['other_trailer_count'] = _ApiClient["default"].convertToType(data['other_trailer_count'], 'Number');
        }

        if (data.hasOwnProperty('owner_operators')) {
          obj['owner_operators'] = _ApiClient["default"].convertToType(data['owner_operators'], 'Number');
        }

        if (data.hasOwnProperty('pad_wrap')) {
          obj['pad_wrap'] = _ApiClient["default"].convertToType(data['pad_wrap'], 'Boolean');
        }

        if (data.hasOwnProperty('payee_type')) {
          obj['payee_type'] = _ApiClient["default"].convertToType(data['payee_type'], 'String');
        }

        if (data.hasOwnProperty('payment_type')) {
          obj['payment_type'] = _ApiClient["default"].convertToType(data['payment_type'], 'String');
        }

        if (data.hasOwnProperty('primary_equipment_type')) {
          obj['primary_equipment_type'] = _ApiClient["default"].convertToType(data['primary_equipment_type'], 'String');
        }

        if (data.hasOwnProperty('reefer_48_foot')) {
          obj['reefer_48_foot'] = _ApiClient["default"].convertToType(data['reefer_48_foot'], 'Number');
        }

        if (data.hasOwnProperty('reefer_53_foot')) {
          obj['reefer_53_foot'] = _ApiClient["default"].convertToType(data['reefer_53_foot'], 'Number');
        }

        if (data.hasOwnProperty('refrigerated_vans')) {
          obj['refrigerated_vans'] = _ApiClient["default"].convertToType(data['refrigerated_vans'], 'Number');
        }

        if (data.hasOwnProperty('rgn')) {
          obj['rgn'] = _ApiClient["default"].convertToType(data['rgn'], 'Number');
        }

        if (data.hasOwnProperty('scac')) {
          obj['scac'] = _ApiClient["default"].convertToType(data['scac'], 'String');
        }

        if (data.hasOwnProperty('small_business_type')) {
          obj['small_business_type'] = _ApiClient["default"].convertToType(data['small_business_type'], 'String');
        }

        if (data.hasOwnProperty('step_decks')) {
          obj['step_decks'] = _ApiClient["default"].convertToType(data['step_decks'], 'Number');
        }

        if (data.hasOwnProperty('straight_trucks')) {
          obj['straight_trucks'] = _ApiClient["default"].convertToType(data['straight_trucks'], 'Number');
        }

        if (data.hasOwnProperty('straps')) {
          obj['straps'] = _ApiClient["default"].convertToType(data['straps'], 'Boolean');
        }

        if (data.hasOwnProperty('super_van')) {
          obj['super_van'] = _ApiClient["default"].convertToType(data['super_van'], 'Number');
        }

        if (data.hasOwnProperty('tanker_trailer_count')) {
          obj['tanker_trailer_count'] = _ApiClient["default"].convertToType(data['tanker_trailer_count'], 'Number');
        }

        if (data.hasOwnProperty('teams')) {
          obj['teams'] = _ApiClient["default"].convertToType(data['teams'], 'Number');
        }

        if (data.hasOwnProperty('tractor_count')) {
          obj['tractor_count'] = _ApiClient["default"].convertToType(data['tractor_count'], 'Number');
        }

        if (data.hasOwnProperty('tri_axle_vans')) {
          obj['tri_axle_vans'] = _ApiClient["default"].convertToType(data['tri_axle_vans'], 'Boolean');
        }

        if (data.hasOwnProperty('vans_48_foot')) {
          obj['vans_48_foot'] = _ApiClient["default"].convertToType(data['vans_48_foot'], 'Number');
        }

        if (data.hasOwnProperty('vans_53_foot')) {
          obj['vans_53_foot'] = _ApiClient["default"].convertToType(data['vans_53_foot'], 'Number');
        }

        if (data.hasOwnProperty('vented_vans')) {
          obj['vented_vans'] = _ApiClient["default"].convertToType(data['vented_vans'], 'Boolean');
        }

        if (data.hasOwnProperty('walking_floor')) {
          obj['walking_floor'] = _ApiClient["default"].convertToType(data['walking_floor'], 'Number');
        }

        if (data.hasOwnProperty('wc_waiver_contact')) {
          obj['wc_waiver_contact'] = _ApiClient["default"].convertToType(data['wc_waiver_contact'], 'String');
        }

        if (data.hasOwnProperty('wc_waiver_date')) {
          obj['wc_waiver_date'] = _ApiClient["default"].convertToType(data['wc_waiver_date'], 'Date');
        }

        if (data.hasOwnProperty('years_in_business')) {
          obj['years_in_business'] = _ApiClient["default"].convertToType(data['years_in_business'], 'Number');
        }
      }

      return obj;
    }
  }]);

  return RMISCarrierProfile;
}();
/**
 * @member {Number} bulk_trailer_count
 */


RMISCarrierProfile.prototype['bulk_trailer_count'] = undefined;
/**
 * @member {Number} cargo_vans
 */

RMISCarrierProfile.prototype['cargo_vans'] = undefined;
/**
 * @member {Number} company_drivers
 */

RMISCarrierProfile.prototype['company_drivers'] = undefined;
/**
 * @member {String} company_rep
 */

RMISCarrierProfile.prototype['company_rep'] = undefined;
/**
 * @member {String} diversity_cert_agency
 */

RMISCarrierProfile.prototype['diversity_cert_agency'] = undefined;
/**
 * @member {Number} double_drops
 */

RMISCarrierProfile.prototype['double_drops'] = undefined;
/**
 * @member {Number} dry_vans
 */

RMISCarrierProfile.prototype['dry_vans'] = undefined;
/**
 * @member {Number} dump
 */

RMISCarrierProfile.prototype['dump'] = undefined;
/**
 * @member {Boolean} email_received
 */

RMISCarrierProfile.prototype['email_received'] = undefined;
/**
 * @member {String} expected_first_move_time
 */

RMISCarrierProfile.prototype['expected_first_move_time'] = undefined;
/**
 * @member {Number} flat_bed_48_foot
 */

RMISCarrierProfile.prototype['flat_bed_48_foot'] = undefined;
/**
 * @member {Number} flat_bed_53_foot
 */

RMISCarrierProfile.prototype['flat_bed_53_foot'] = undefined;
/**
 * @member {Number} flat_beds
 */

RMISCarrierProfile.prototype['flat_beds'] = undefined;
/**
 * @member {Number} garment_trailer
 */

RMISCarrierProfile.prototype['garment_trailer'] = undefined;
/**
 * @member {Boolean} has_can_auth
 */

RMISCarrierProfile.prototype['has_can_auth'] = undefined;
/**
 * @member {Boolean} has_carb_cert
 */

RMISCarrierProfile.prototype['has_carb_cert'] = undefined;
/**
 * @member {Boolean} has_ctpat_cert
 */

RMISCarrierProfile.prototype['has_ctpat_cert'] = undefined;
/**
 * @member {Boolean} has_fast_cert
 */

RMISCarrierProfile.prototype['has_fast_cert'] = undefined;
/**
 * @member {Boolean} has_mex_interchange
 */

RMISCarrierProfile.prototype['has_mex_interchange'] = undefined;
/**
 * @member {Boolean} has_safety_permit_hm_32
 */

RMISCarrierProfile.prototype['has_safety_permit_hm_32'] = undefined;
/**
 * @member {Boolean} has_smartway_cert
 */

RMISCarrierProfile.prototype['has_smartway_cert'] = undefined;
/**
 * @member {Boolean} has_twice_cert
 */

RMISCarrierProfile.prototype['has_twice_cert'] = undefined;
/**
 * @member {Boolean} hazmat_cert_verified_by_rmis
 */

RMISCarrierProfile.prototype['hazmat_cert_verified_by_rmis'] = undefined;
/**
 * @member {Boolean} hazmat_certified
 */

RMISCarrierProfile.prototype['hazmat_certified'] = undefined;
/**
 * @member {Number} heated_vans
 */

RMISCarrierProfile.prototype['heated_vans'] = undefined;
/**
 * @member {Number} hopper
 */

RMISCarrierProfile.prototype['hopper'] = undefined;
/**
 * @member {Number} intermodal_trailer_count
 */

RMISCarrierProfile.prototype['intermodal_trailer_count'] = undefined;
/**
 * @member {Boolean} is_factoring
 */

RMISCarrierProfile.prototype['is_factoring'] = undefined;
/**
 * @member {Boolean} is_special_contract
 */

RMISCarrierProfile.prototype['is_special_contract'] = undefined;
/**
 * @member {Number} maxi
 */

RMISCarrierProfile.prototype['maxi'] = undefined;
/**
 * @member {String} minority_women_owned
 */

RMISCarrierProfile.prototype['minority_women_owned'] = undefined;
/**
 * @member {Boolean} no_w9
 */

RMISCarrierProfile.prototype['no_w9'] = undefined;
/**
 * @member {Number} open_top
 */

RMISCarrierProfile.prototype['open_top'] = undefined;
/**
 * @member {Number} other_trailer_count
 */

RMISCarrierProfile.prototype['other_trailer_count'] = undefined;
/**
 * @member {Number} owner_operators
 */

RMISCarrierProfile.prototype['owner_operators'] = undefined;
/**
 * @member {Boolean} pad_wrap
 */

RMISCarrierProfile.prototype['pad_wrap'] = undefined;
/**
 * @member {String} payee_type
 */

RMISCarrierProfile.prototype['payee_type'] = undefined;
/**
 * @member {String} payment_type
 */

RMISCarrierProfile.prototype['payment_type'] = undefined;
/**
 * @member {String} primary_equipment_type
 */

RMISCarrierProfile.prototype['primary_equipment_type'] = undefined;
/**
 * @member {Number} reefer_48_foot
 */

RMISCarrierProfile.prototype['reefer_48_foot'] = undefined;
/**
 * @member {Number} reefer_53_foot
 */

RMISCarrierProfile.prototype['reefer_53_foot'] = undefined;
/**
 * @member {Number} refrigerated_vans
 */

RMISCarrierProfile.prototype['refrigerated_vans'] = undefined;
/**
 * @member {Number} rgn
 */

RMISCarrierProfile.prototype['rgn'] = undefined;
/**
 * @member {String} scac
 */

RMISCarrierProfile.prototype['scac'] = undefined;
/**
 * @member {String} small_business_type
 */

RMISCarrierProfile.prototype['small_business_type'] = undefined;
/**
 * @member {Number} step_decks
 */

RMISCarrierProfile.prototype['step_decks'] = undefined;
/**
 * @member {Number} straight_trucks
 */

RMISCarrierProfile.prototype['straight_trucks'] = undefined;
/**
 * @member {Boolean} straps
 */

RMISCarrierProfile.prototype['straps'] = undefined;
/**
 * @member {Number} super_van
 */

RMISCarrierProfile.prototype['super_van'] = undefined;
/**
 * @member {Number} tanker_trailer_count
 */

RMISCarrierProfile.prototype['tanker_trailer_count'] = undefined;
/**
 * @member {Number} teams
 */

RMISCarrierProfile.prototype['teams'] = undefined;
/**
 * @member {Number} tractor_count
 */

RMISCarrierProfile.prototype['tractor_count'] = undefined;
/**
 * @member {Boolean} tri_axle_vans
 */

RMISCarrierProfile.prototype['tri_axle_vans'] = undefined;
/**
 * @member {Number} vans_48_foot
 */

RMISCarrierProfile.prototype['vans_48_foot'] = undefined;
/**
 * @member {Number} vans_53_foot
 */

RMISCarrierProfile.prototype['vans_53_foot'] = undefined;
/**
 * @member {Boolean} vented_vans
 */

RMISCarrierProfile.prototype['vented_vans'] = undefined;
/**
 * @member {Number} walking_floor
 */

RMISCarrierProfile.prototype['walking_floor'] = undefined;
/**
 * @member {String} wc_waiver_contact
 */

RMISCarrierProfile.prototype['wc_waiver_contact'] = undefined;
/**
 * @member {Date} wc_waiver_date
 */

RMISCarrierProfile.prototype['wc_waiver_date'] = undefined;
/**
 * @member {Number} years_in_business
 */

RMISCarrierProfile.prototype['years_in_business'] = undefined;
var _default = RMISCarrierProfile;
exports["default"] = _default;